import { useContent } from '../../../content/ContentProvider';

export default function Footer() {
  const content = useContent();
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) element.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 py-16">
        <div className="grid md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-5">
              <div className="bg-white p-1.5 rounded-xl shadow-md border border-gray-200/20 flex items-center justify-center transition-all hover:scale-105 duration-200">
                <img
                  src={content.global.logo}
                  alt={content.brand.name}
                  className="h-10 md:h-12 w-auto object-contain"
                />
              </div>
              <div>
                <div className="text-lg font-bold">{content.brand.name}</div>
                <div className="text-xs text-gray-400">Community Support Services</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed mb-5 max-w-sm">
              {content.footer.description}
            </p>
            <p className="text-sm text-teal-400 font-medium">{content.footer.domain}</p>
            <div className="flex gap-3 mt-5">
              {content.global.socialLinks.map((s, i) => (
                <a key={i} href={s.link} rel="nofollow" className="w-9 h-9 flex items-center justify-center bg-gray-800 hover:bg-teal-600 rounded-lg transition-colors cursor-pointer">
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-5">Quick Links</h4>
            <ul className="space-y-3">
              {content.global.navLinks.map((link) => (
                <li key={link.id}>
                  <button onClick={() => scrollToSection(link.id)} className="text-sm text-gray-400 hover:text-teal-400 transition-colors cursor-pointer">
                    {link.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-bold uppercase tracking-wider text-gray-300 mb-5">Contact</h4>
            <ul className="space-y-4">
              {content.global.contactInfo.map((info, i) => (
                <li key={i} className="flex items-start gap-3">
                  <i className={`${info.icon} text-teal-400 mt-0.5`}></i>
                  {info.type === 'email' ? (
                    <a href={`mailto:${info.value}`} className="text-sm text-gray-400 hover:text-teal-400 transition-colors">{info.value}</a>
                  ) : info.type === 'tel' ? (
                    <a href={`tel:${info.value.replace(/[^0-9+]/g, '')}`} className="text-sm text-gray-400 hover:text-teal-400 transition-colors">{info.value}</a>
                  ) : (
                    <span className="text-sm text-gray-400">{info.value}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-xs text-gray-500">
            © {content.footer.copyrightYear} {content.brand.fullName}. {content.footer.rights} |{' '}
            <a href="https://bettayou.org" rel="nofollow" className="hover:text-teal-400 transition-colors">bettayou.org</a>
          </p>
          <p 
            className="text-xs text-gray-500" 
            dangerouslySetInnerHTML={{ __html: content.footer.madeWithLove }} 
          />
        </div>
      </div>
    </footer>
  );
}
